import { render, staticRenderFns } from "./AddBlockBeforeBox.vue?vue&type=template&id=5d6d73d4&scoped=true&"
import script from "./AddBlockBeforeBox.vue?vue&type=script&lang=js&"
export * from "./AddBlockBeforeBox.vue?vue&type=script&lang=js&"
import style0 from "./AddBlockBeforeBox.vue?vue&type=style&index=0&id=5d6d73d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6d73d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VBtn,VIcon,VOverlay})
